import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_BUTTON_UNDO, } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { ISnackbarWithAlternativeActionUndo } from './types';
import { snackbarUndoDefault } from '../variantUndo/snackbarUndoDefault'

export const snackbarUndoWithAlternativeAction = (
    options: ISnackbarWithAlternativeActionUndo,
) => {
    return (dispatch: Dispatch) => {
        options.buttons = [
            {
                onClick: () => {
                    dispatch(getDefaultActionEvent(options.id, options.actionAlternative));
                },
                text: options.alternativeButton
            },
            {
                onClick: () => {
                    dispatch(getDefaultActionEvent(options.id, options.actionUndo));
                },
                text: SNACKBAR_BUTTON_UNDO,
                isPrimary: true,
                isTimer: true,
            },
        ];
        dispatch(snackbarUndoDefault(options));
    }
};
